module.exports = __webpack_public_path__ + "img/tabler_mail.30614cbf.svg";